  export const defaultStyle ={
    languageWrapperBtn: "languageWrapperBtn bg-cover mt-[35px]  max-w-[97px] lg:mt-0 bg-no-repeat p-[5px] relative self-center",
    wrapper: " z-[9] language-selector font-MDLZBiteType bg-purple text-left min-w-[87px] pr-[15px] uppercase text-white text-[14px]",
    languageList: "language-list text-[14px]",
    selectedLang:"pl-[5px] pr-[10px] inline-flex h-[30px] lg:h-[24px] items-center ",
    option:"flex px-[10px] gap-x-10 [&>img]:w-[15px]"
  }
